import { Controller } from "stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = ["fileInput"]

  connect() {

    this.fileInputTarget.addEventListener("change", this.uploadFiles.bind(this))

    document.addEventListener("direct-upload:initialize", this.onUploadInitialize.bind(this))
    document.addEventListener("direct-upload:progress", this.onUploadProgress.bind(this))
    document.addEventListener("direct-upload:end", this.onUploadEnd.bind(this))
    document.addEventListener("direct-upload:error", this.onUploadError.bind(this))
  }

  uploadFiles(event) {
    const files = event.target.files
    if (!files.length) return

    Array.from(files).forEach(file => {
      this.insertProgressBar(file)

      const upload = new DirectUpload(file, "/rails/active_storage/direct_uploads")
      upload.create((error, blob) => {
        if (error) {
          this.showError(file.name, error)
        } else {
          this.insertHiddenBlobInput(blob)
        }
      })
    })
  }

  insertProgressBar(file) {
    const uploadId = this.generateUploadId(file)
    const progressWrapper = document.querySelector(".direct-upload-progress-wrapper")

    // Truncate filename to 10 chars and keep extension
    const nameParts = file.name.split(".");
    let base = nameParts.slice(0, -1).join(".");
    const ext = nameParts.length > 1 ? "." + nameParts[nameParts.length - 1] : "";
    if (base.length > 10) {
      base = base.slice(0, 10);
      base += "...";
    }
    const displayName = base + ext;
    const filesContainer = document.querySelector("#files-container.d-flex.flex-row")
    if (filesContainer) {
      filesContainer.insertAdjacentHTML("beforeend", `
      <div id="direct-upload-${uploadId}" class="direct-upload direct-upload--pending mb-2">
        <div class="d-flex flex-row align-items-center mb-1">
          <span class="far fa-file-alt mr-2"></span>
          <div class="direct-upload__filename">${displayName}</div>
        </div>
        <div class="direct-upload__progress-bar" id="direct-upload-progress-${uploadId}" style="width: 0%; height: 4px;"></div>
      </div>
      `)
    }

    document.dispatchEvent(new CustomEvent('MessageAppended', {
      bubbles: true,
      detail: { scrolled: true }
    }));
  }

  insertHiddenBlobInput(blob) {
    const hiddenField = document.createElement("input")
    hiddenField.setAttribute("type", "hidden")
    hiddenField.setAttribute("value", blob.signed_id)
    hiddenField.name = "attachment_ids[]"
    document.getElementById("ai-chat-form").appendChild(hiddenField)
  }

  showError(filename, error) {
    const progressWrapper = document.querySelector(".direct-upload-progress-wrapper")
    progressWrapper.insertAdjacentHTML("beforeend", `
      <div class="direct-upload direct-upload--error mb-2" title="${error}">
        <div class="direct-upload__filename mb-1">${filename}</div>
      </div>
    `)
  }

  onUploadInitialize(event) {
    const file = event.detail.file
    const uploadId = this.generateUploadId(file)
    const element = document.getElementById(`direct-upload-${uploadId}`)
    if (element) {
      element.classList.remove("direct-upload--pending")
    }
  }

  onUploadProgress(event) {
    const { file, progress } = event.detail
    const uploadId = this.generateUploadId(file)
    // Support multiple files: update the correct progress bar for each file
    const progressElement = document.getElementById(`direct-upload-progress-${uploadId}`)
    if (progressElement) {
      progressElement.style.width = `${progress}%`
    }
  }

  onUploadEnd(event) {
    const file = event.detail.file
    const uploadId = this.generateUploadId(file)
    const element = document.getElementById(`direct-upload-${uploadId}`)
    const filesContainer = document.querySelector("#files-container.d-flex.flex-row")
  
    if (element) {
      element.classList.add("direct-upload--complete")
  
      // Remove the element after a short delay
      setTimeout(() => {
        // Remove all children from the filesContainer
        while (filesContainer.firstChild) {
          filesContainer.removeChild(filesContainer.firstChild)
        }
      }, 2000)
    }
  } 

  onUploadError(event) {
    const { file, error } = event.detail
    const uploadId = this.generateUploadId(file)
    const element = document.getElementById(`direct-upload-${uploadId}`)
    if (element) {
      element.classList.add("direct-upload--error")
      element.setAttribute("title", error)
    }
  }

  generateUploadId(file) {
    // Simple unique id based on filename and lastModified
    return `${file.name.replace(/\W/g, "")}-${file.lastModified}`
  }

  validateFile() {
    const file = this.fileInputTarget.files[0]
    if (!file) return

    const maxSize = 5 * 1024 * 1024 // 5 MB
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"]

    if (file.size > maxSize) {
      this.showError(`File size exceeds ${maxSize / 1024 / 1024} MB.`)
      this.clearFileInput()
    } else if (!allowedTypes.includes(file.type)) {
      this.showError(`File type ${file.type} is not allowed.`)
      this.clearFileInput()
    } else {
      this.clearError()
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.innerText = message
    } else {
      alert(message)
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.innerText = ""
    }
  }

  clearFileInput() {
    this.fileInputTarget.value = ""
  }
}
